import React from 'react';
import styled from 'styled-components';
import Typo from '../Typo';
import { media } from '../../utils/media';
import Progress from '../Progress';
import Flex from '../Flex';
import { getUserThemeColor } from '../theme/colors';

const CourseInformation = styled.div`
  padding: ${({ $extraPadding }) => ($extraPadding ? '3rem 1rem 1rem' : '12px 24px 24px')};
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  gap: 16px;
  background-color: white;

  ${media.lessThan('tablet')} {
    height: auto;
    flex: 1;
  }
`;

const Description = styled(Typo.SmallText)`
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  text-overflow: ellipsis;
`;

const CourseInfoWrapper = ({ course, showProgress, children, ownerColor, extraPadding, ownerName }) => {
  const { name, description, progress, expires } = course;
  const themeColor = getUserThemeColor(ownerColor);

  return (
    <CourseInformation $extraPadding={extraPadding}>
      <Flex align='flex-start' direction='column' auto>
        <Flex direction='column' width='100%' align='flex-start'>
          {ownerName && <Typo.Info $caps>{ownerName}</Typo.Info>}
          <Typo.TextTitle>{name}</Typo.TextTitle>
        </Flex>
        {description && <Description>{description}</Description>}
      </Flex>
      {showProgress && <Progress progress={progress * 100} expires={expires} bgcolor={themeColor} />}
      {children}
    </CourseInformation>
  );
};

export default CourseInfoWrapper;
